import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function FamilyLaw() {
  return (
     <motion.div
      className="max-w-4xl mx-auto px-6 py-12 text-center"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
    >
    
      <h1 className="text-3xl md:text-4xl font-bold mb-6">Family Law</h1>
      <p className="text-lg text-gray-700 leading-relaxed mb-8 text-left">
We guide clients through some of life’s most personal and challenging transitions with compassion, clarity, and strategic legal support. We handle a wide range of family law matters, including separation, divorce, parenting, child support, spousal support, property division, cohabitation agreements, and separation agreements.
Whether you are navigating the early stages of separation, negotiating parenting plans, or resolving complex property issues, we offer a balanced and practical approach that protects your rights while keeping long-term family stability in mind.
We understand the emotional and financial strain that often accompanies family law disputes. That is why we focus on providing clear advice, effective negotiation, and when needed, strong advocacy in court. Our goal is to help you reach fair, workable solutions that support your well-being and the best interests of your children.
With Falcon Law, you can expect responsive communication, thoughtful guidance, and a commitment to achieving resolution with dignity and respect.

      </p>
      <Link
        to="/contact"
        className="inline-block px-6 py-3 rounded-lg bg-blue-900 text-white font-semibold shadow hover:bg-blue-800 transition"
      >
        Request Consultation
      </Link>
      </motion.div>
    
  );
}
